import BootstrapTable from 'react-bootstrap-table-next';
import React , {Component} from 'react';
import firebase from 'firebase';
import {Link} from 'react-router-dom';
import store from '../../store';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';


const database=firebase.database();

const styles={marginTop:'40px'}

const columns = [{
	dataField: 'cliente',
	text: 'cliente',
	sort: true,
	filter: textFilter()
  }, {
	dataField: 'empresa',
	text: 'empresa',
	sort: true,
	filter: textFilter()
  },{
	dataField: 'fechaBajada',
	text: 'fechaBajada',
	sort: true,
	filter: textFilter()
  },{
	dataField: 'pago',
	text: 'pago',
	sort: true,
	filter: textFilter()
  },
  {
	dataField: 'total',
	text: 'total',
	sort: true,
	filter: textFilter()
  },{
	dataField: 'lugar',
	text: 'lugar',
	sort: true,
	filter: textFilter()
  }];
  

class ViajesUsuarios extends Component{
	
	constructor(props){
		
		super(props);
		this.state={
				empresas:[],
				clientes:[],
				viajes:[],
				viajestemp:[],
				labels:['Cliente','Empresa','Fecha','Tipo de Pago','Monto','Lugar'],
				fecha_actual:'',
				fecha_minima:'',				
				input_disabled:'disabled'
				
		}
		
		this.clientesRef=database.ref().child('Clientes');
		this.viajesRef=database.ref().child('Viaje');
		this.empresaRef=database.ref().child('Empresa');
		this.handleClickPrint=this.handleClickPrint.bind(this);
		
		this.changeStatePrint=this.changeStatePrint.bind(this);
		this.handleKeyPress=this.handleKeyPress.bind(this);
		
		
		this.handleFilter=this.handleFilter.bind(this);
		
		
		this.handleInputDate1Changed=this.handleInputDate1Changed.bind(this);
		this.handleInputDate2Changed= this.handleInputDate2Changed.bind(this);
		this.handleOnClickRegistrosGenerales=this.handleOnClickRegistrosGenerales.bind(this);
		
		this.renderContent=this.renderContent.bind(this);
		
		
		
		let f=new Date();
		
		this.state.fecha_actual=f.getFullYear()+'-'+((f.getMonth()+1)>10 ? f.getMonth:'0'+(f.getMonth()+1))+'-'+(f.getDate()>10?f.getDate():'0'+f.getDate());
		
		
		
	}
	
	
	componentDidMount(){
				
		this.empresaRef.on('value',this.gotDataEmpresa,this.errDataEmpresa);
		
		

	}
	
	
	componentWillMount(){
		
		this.empresaRef.on('value',this.gotDataEmpresa,this.errDataEmpresa);
		
	}
	
	gotDataClientes=(data)=>{
		
		let newCliente=[];
		
		if(data.val()!==null){
			
			let dataclientes=data.val();
			
			
			let keys=Object.keys(dataclientes);
			
			for(let i=0;i<keys.length;i++){
				
				let k=keys[i];
				
				let empresa=this.state.empresas.find(empresas=>empresas.key===dataclientes[k].socio);
				
				
				let nombre_empresa=(empresa!==undefined)? empresa.codigo_empresa:"No";
				
				
				newCliente.push({
					key:k,
					nombre:dataclientes[k].nombre,
					apellido:dataclientes[k].apellido,
					empresa:nombre_empresa
					
				})
		
			}
			this.setState({clientes:newCliente});
		
			this.viajesRef.on('value',this.gotDataViajes,this.errDataViajes);
		}
		
		
	}
	errDataClientes=(err)=>{
		
		console.log(err);
	}
	
	gotDataViajes=(data)=>{
		
		
		let newViaje=[];
		
		if(data.val()!==null){
			
			let dataviajes=data.val();
			let keys=Object.keys(dataviajes);
				
			
			for(let i=0;i<keys.length;i++){
			
				let k=keys[i];
				
			
				let cliente_viaje=this.state.clientes.find(clientes=>clientes.key===dataviajes[k].cliente);
				
				let nombre_cliente=(cliente_viaje!==undefined)?cliente_viaje.nombre+' '+cliente_viaje.apellido:" ";
				let empresa_cliente=(cliente_viaje!==undefined)?cliente_viaje.empresa:" ";
		
		
				if(dataviajes[k].total!==undefined){
						
					newViaje.push({
						key:k,
						cliente:nombre_cliente,
						fechaReserva:(dataviajes[k].fechaReserva!==undefined)?new Date(dataviajes[k].fechaReserva):'',
						fechaSubida:(dataviajes[k].fechaSubida!==undefined)?new Date(dataviajes[k].fechaSubida):'',
						fechaBajada:(dataviajes[k].fechaBajada!==undefined)?new Date(dataviajes[k].fechaBajada):'',
						empresa:empresa_cliente,
						pago:dataviajes[k].pago,
						lugar:dataviajes[k].lugar,
						total:'$'+dataviajes[k].total
					})
					
					
				}
				
			
			}
			this.setState({viajes:newViaje,viajestemp:newViaje});
			
		}
		
	}
	errDataViajes=(err)=>{
		
		console.log(err);
		
	}
	
	
	gotDataEmpresa=(data)=>{
		
		let newEmpresa=[];
		
		if(data.val()!==null){
			
			let dataempresa=data.val();
			
			let keys=Object.keys(dataempresa);
			
			for(let i=0;i<keys.length;i++){
				
				let k=keys[i];
				
				newEmpresa.push({
					key:k,
					codigo_empresa:dataempresa[k].codigo_empresa				

				})
						
			}
		    this.setState({empresas:newEmpresa});
			
			this.clientesRef.on('value',this.gotDataClientes,this.errDataClientes);
		}
		
		
	}
	errDataEmpresa=(err)=>{
		
		console.log(err);
		
	}
	
	
	handleClickPrint(){
			
			
		this.changeStatePrint();
		
	}
	
	changeStatePrint(){
		
		store.dispatch({
			
			type: "STATE_REPORT",
			labels_report:this.state.labels,
			data_report:this.state.viajes,
			tipo_reporte:'viajes_usuarios'
		})
		
		
	}
	
	handleKeyPress(event){
		
		let newViajes=[]
			
		
		this.state.viajes=this.state.viajestemp;
		

			
				for(let i=0;i<this.state.viajes.length;i++){
					
				
					let comprobar=this.state.viajes[i].cliente.toLowerCase().search(this.busqueda.value.toLowerCase()) >=0 ? true:false;
					
					let empresa=this.state.viajes[i].empresa.toLowerCase().search(this.busqueda.value.toLowerCase())>=0? true : false;
					let fecha=this.state.viajes[i].fechaBajada.toLowerCase().search(this.busqueda.value.toLowerCase())>=0 ? true : false;
					let pago=this.state.viajes[i].pago.toLowerCase().search(this.busqueda.value.toLowerCase())>=0 ? true : false;
					let total=this.state.viajes[i].total.toLowerCase().search(this.busqueda.value.toLowerCase())>=0 ? true : false;
					
					let lugar=false;

					if(this.state.viajes[i].lugar!==null && this.state.viajes[i].lugar!==undefined){
						lugar=this.state.viajes[i].lugar.toLowerCase().search(this.busqueda.value.toLowerCase())>=0 ? true : false;
					}
					
					

					
					if(comprobar || empresa || fecha || pago || total || lugar){
					
						newViajes.push({
							key:this.state.viajes[i].key,
							cliente:this.state.viajes[i].cliente,
							empresa:this.state.viajes[i].empresa,
							fechaBajada:this.state.viajes[i].fechaBajada,
							pago:this.state.viajes[i].pago,
							total:this.state.viajes[i].total,
							lugar:(this.state.viajes[i].lugar!==undefined)?this.state.viajes[i].lugar:""
							
						})
					
			
					}
						
					
							
				}
				
				this.state.viajes=newViajes;
				this.setState({viajes:newViajes});
				
				
			
		
		
	}
	
	
	handleFilter(){
		
		this.handleKeyPress();
		
		
		let f1=new Date('2018-03-02');
		let f2=new Date('2018-03-04');
		
		
		
		
		let newArray=[];
		
		
		for(let i=0;i<this.state.viajes.length;i++){
			
			if(this.state.viajes[i].fechaBajada!==undefined && this.state.viajes[i].fechaBajada!==""){
				
				let fecha_registro=new Date(this.state.viajes[i].fechaBajada);
				
				
				if(fecha_registro.getTime()>=f1.getTime() && fecha_registro.getTime()<=f2.getTime()){
				
					
					newArray.push({
						
							key:this.state.viajes[i].key,
							cliente:this.state.viajes[i].cliente,
							empresa:this.state.viajes[i].empresa,
							fechaBajada:this.state.viajes[i].fechaBajada,
							pago:this.state.viajes[i].pago,
							total:this.state.viajes[i].total,
							lugar:(this.state.viajes[i].lugar!==undefined)?this.state.viajes[i].lugar:""
						
					})
					
					
				}
				
				
				
			}
			
			
		}
		
		this.setState({
			
			viajes:newArray
			
		})
		
		
	}
	
	handleInputDate1Changed(){
		
		this.setState({
			fecha_minima:this.fecha1.value,
			input_disabled:''
		})
		
		if(this.fecha2.value!==""){
			
			this.fecha2.value="";

	
		}
		
	}
	
	handleInputDate2Changed(){

		

		

		let inputDateInicio=this.fecha1.value;
		let inputDateFin=this.fecha2.value;
		
		let f1=new Date(inputDateInicio);
		let f2=new Date(inputDateFin);
		
	
		let newArray=[];
		
		
		for(let i=0;i<this.state.viajes.length;i++){
			
			if(this.state.viajes[i].fechaBajada!==undefined && this.state.viajes[i].fechaBajada!==""){
				
				let fecha_registro=new Date(this.state.viajes[i].fechaBajada);
				
				
				if(fecha_registro.getTime()>=f1.getTime() && fecha_registro.getTime()<=f2.getTime()){
				
					
					newArray.push({
						
							key:this.state.viajes[i].key,
							cliente:this.state.viajes[i].cliente,
							empresa:this.state.viajes[i].empresa,
							fechaBajada:this.state.viajes[i].fechaBajada,
							pago:this.state.viajes[i].pago,
							total:this.state.viajes[i].total,
							lugar:(this.state.viajes[i].lugar!==undefined)?this.state.viajes[i].lugar:""
						
					})
					
					
				}
							
				
			}
			
			
		}
		
		this.setState({
			
			viajes:newArray
			
		})
	
	}
	
	
	handleOnClickRegistrosGenerales(){
	
		this.fecha1.value="";
		this.fecha2.value="";
		this.setState({
			input_disabled:'disabled',
			fecha_minima:'',
			viajes:this.state.viajestemp
	
		})
		
		
	}


	renderContent(){
		
		
		
		if(this.state.clientes.length!==0 && this.state.empresas.length!==0 && this.state.viajes.length!==0){
			
			
			return(
			
				
				
				<div className="render-content">
			
				<center><h3>Viajes por Usuarios</h3></center>
					
			

				<div className="row" style={styles}>
				
					<div className="col-md-3">
						<br/>
						<Link to="template" className="btn btn-success" onClick={this.handleClickPrint}><span className="glyphicon glyphicon-print"> Imprimir</span></Link>
					</div>
					
					<div className="col-md-3">
						<div className="form-group">
							<label>Fecha Inicio</label>
							<input type="date" className="form-control" max={this.state.fecha_actual} onChange={this.handleInputDate1Changed}
								ref={input=>{this.fecha1=input;}}							
							/>
						</div>
					</div>
					
					<div className="col-md-3">
						<div className="form-group">
							<label>Fecha Final</label>
							<input type="date" className="form-control" max={this.state.fecha_actual} min={this.state.fecha_minima} disabled={this.state.input_disabled}
								ref={input=>{this.fecha2=input;}} onChange={this.handleInputDate2Changed}
							/>
						</div>
					</div>
					
					<div className="col-md-3">
						<div className="form-group">
							<label></label><br/>
							<button type="button" className="btn btn-primary" onClick={this.handleOnClickRegistrosGenerales}>Reestablecer fechas</button>
						</div>
					</div>
				
				
				</div>
				
				
				
				<BootstrapTable
					keyField="id"
					data={ this.state.viajes }
					columns={ columns }
					striped
					hover
					condensed
					pagination={ paginationFactory() }
					filter={ filterFactory() }
					/>
			
				</div>
			
			
			
			);
			
			
			
		}
		
		
		
	}

	
	
	render(){

		
		return(
		
			<div className="reporte_viajes container">
			
			
			{this.renderContent()}
			
			</div>
		
		)
		
		
	}
	
	
}

export default ViajesUsuarios;


// WEBPACK FOOTER //
// ./src/Components/Reportes/ViajesUsuarios.jsx